
export default {
  name:'speaking'
};
